// 子组件：预订弹窗
import React from 'react'
import { CenterPopup } from 'antd-mobile'
import { CloseOutline } from 'antd-mobile-icons'
import PopupProducts from './PopupProducts'
import  './index.less'
import styles from '../../components/JmModal/index.module.less'

const BookingModal = React.memo(({ visible, products, onClose, onItemClick }) => {
    if (!visible || !products.length) return null
    
    return (
        <CenterPopup
            visible={visible}
            onClose={onClose}
            closeOnMaskClick
            destroyOnClose
            bodyStyle={{ backgroundColor: 'transparent' }}
            style={{ '--min-width': '92%' }}
        >
            <div className={`${styles.jmModal} p10`} style={{ backgroundColor: '#fff' }}>
                <div className={`${styles.modalContent}`} style={{ minHeight: 200 }}>
                    <PopupProducts 
                        list={products} 
                        showPMDetail={onItemClick} 
                        cls='pd-list-vertical' 
                    />
                </div>
            </div>
            <div className={styles.modalClose}>
                <CloseOutline fontSize={28} color='#fff' onClick={onClose} />
            </div>
        </CenterPopup>
    )
})

export default BookingModal